import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import clsx from 'clsx'
import {BatchName} from './BatchName'
import {OptionKey} from './BatchScanResult'
import {ModalTemplate} from '../../template'

type Props = {
  show: boolean
  handleClose: () => void
  handleSuccess: () => void
}

const OPTIONS: {id: OptionKey; label: string; subLabel: string}[] = [
  {
    id: 'new',
    label: 'CREATE_NEW_A1_BATCH',
    subLabel: 'GIVE_A_UNIQUE_NAME_FOR_YOUR_A1_BATCH',
  },
  {
    id: 'existing',
    label: 'ADD_TO_EXISTING_A1_BATCH',
    subLabel: 'SELECT_A_A1_BATCH_TO_ADD_YOUR_ORDER_TO',
  },
]

const BatchScan: React.FC<Props> = ({show, handleClose, handleSuccess}) => {
  const intl = useIntl()
  const [showModal, setShowModal] = useState<{batch_name: boolean}>({batch_name: false})

  const [selected, setSelected] = useState<OptionKey | undefined>(undefined)

  const handleCloseModal = () => {
    setSelected(undefined)
    handleClose()
  }

  return (
    <>
      {showModal.batch_name && selected && (
        <BatchName
          show={showModal.batch_name}
          handleClose={() => {
            setShowModal((prev) => ({...prev, batch_name: false}))
            handleCloseModal()
          }}
          type={selected}
          handleSuccess={handleSuccess}
        />
      )}
      <ModalTemplate
        id='gori_modal_a1_batch_scan'
        show={show && !showModal.batch_name}
        handleClose={handleCloseModal}
        dialogClassName='modal-size-md h-auto'
        contentClassName='modal-padding'
        title='SCAN_TO_BATCH'
        bodyClassName='vh-75 overflow-auto'
        titlePrimaryBtn='NEXT'
        disabledPrimaryBtn={!selected}
        onClickPrimaryBtn={() => setShowModal((prev) => ({...prev, batch_name: true}))}
      >
        {OPTIONS.map((option) => (
          <div
            key={option.id}
            onClick={() => setSelected(option.id)}
            className={clsx('border rounded-3 mb-6 p-6 cursor-pointer', {
              'border-primary bg-light-primary': selected === option.id,
              'border-secondary': selected !== option.id,
            })}
          >
            <h3>{intl.formatMessage({id: option.label})}</h3>
            <div>{intl.formatMessage({id: option.subLabel})}</div>
          </div>
        ))}
      </ModalTemplate>
    </>
  )
}

export {BatchScan}
